import clsx from 'clsx'
import { ButtonHTMLAttributes, useMemo } from 'react'
import './styles.css'

interface GradientButtonProps
  extends React.DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  gradient?: string
}

export function GradientButton({
  className,
  children,
  gradient = `linear-gradient(154deg, rgb(255 255 255 / 0%) 72.31%, rgb(255 255 255 / 80%) 91.16%), linear-gradient(155deg, rgb(255 255 255 / 90%) -2.67%, rgb(255 255 255 / 9%) 52.33%)`,
  ...props
}: GradientButtonProps) {
  const rotatingGradient = useMemo(
    () =>
      gradient?.replace(
        /linear-gradient\(\s*([^,]+),/g,
        `linear-gradient(calc($1 + var(--rotation)),`,
      ),
    [gradient],
  )

  return (
    <button {...props} className={clsx('gradient-btn group', className)}>
      <div
        className="gradient-border"
        style={{ background: rotatingGradient }}
      />
      <div className="px-3 py-1 min-950:px-6 min-950:py-2 bg-black overflow-hidden rounded-full transition-all duration-300 ease-in-out group-hover:bg-layered-gray-overlay">
        {children}
      </div>
    </button>
  )
}
